import React from 'react';

const Guidelines = ({ children, pageContext: {
  frontmatter: { title },
}}) => title
  ? (
    <div>
      <div className="page-header">
        <p>Guidelines</p>
        <h1>
          {title}
        </h1>
      </div>
      <div className="page-content page-content--guidelines">
        {children}
      </div>
    </div>
  ) : children;

export default Guidelines;
